/* 문화포럼 일정 등록 페이지 */import Box from '@mui/material/Box';
import React, {useEffect, useRef, useState} from 'react';
import {constance} from '../../common/constance/constance';
import Stack from '@mui/material/Stack';
import {config} from '../../common/config/config';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import {styles} from '../../common/style';
import {Button, MenuItem, MenuList, Paper} from '@mui/material';
import {common} from '../../common/common';
import ImageUploading from 'react-images-uploading';
import {useNavigate} from 'react-router-dom';
import {User} from '../../interface/user.interface';
import {Club} from "../../interface/club.interface";


interface State {
    workplace: { name: string, value: number },
    listOpen: boolean
}

function WorkplaceComponent(props: { workplaceRef: any, useAllWorkplace: string }) {

    const [state, setState] = useState<State>({
        workplace: {name: '용인', value: 10},
        listOpen: false,
    });

    function handleOpenList() {
        setState({
            ...state,
            listOpen: true,
        })
    }

    function handleChangePresenter(e: React.MouseEvent<HTMLLIElement>, workplace: { name: string, value: number }) {
        setState({
            ...state,
            workplace: workplace,
            listOpen: false
        })
    }

    return (
        <React.Fragment>
            {/* Value */}
            <TextField inputRef={props.workplaceRef}
                       value={state.workplace.value}
                       sx={{display: 'none'}}
            />
            {/* Name */}
            <TextField placeholder="사업장을 선택해주세요."
                       value={state.workplace.name}
                       onClick={handleOpenList}
                       variant="outlined"
                       sx={{width: 1, backgroundColor: 'var(--scc-surface)', borderRadius: 1}}
            />
            <Paper sx={{
                width: 320, maxWidth: '100%',
                position: 'absolute',
                maxHeight: '400px',
                overflowY: 'auto',
                zIndex: 10,
                display: state.listOpen ? 'flex' : 'none',
            }}>
                <MenuList sx={{width: 1,}}>
                    {
                        Object.keys(constance.workplace).map((key: string, index: number) => {
                            let workplace: { name: string, value: number } = constance.workplace[key];
                            console.log(workplace);

                            if (props.useAllWorkplace === 'N' && workplace.value == 0) return;

                            return (
                                <MenuItem value={workplace.value}
                                          key={index}
                                          sx={{width: 1}}
                                          onClick={(e) => handleChangePresenter(e, workplace)}>
                                    <Typography>
                                        {`${workplace.name}`}
                                    </Typography>
                                </MenuItem>
                            );
                        })
                    }

                </MenuList>
            </Paper>
        </React.Fragment>
    )
}

export default WorkplaceComponent;